import {
    Children,
    type FC
} from "react";
import {
    View
} from "react-native";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    EmptyPartContentProps,
    IEmptyMediaProps
} from "../../type";
import {
    withEmptyContext
} from "../../context";
import {
    EMPTY_TYPE_ICONS
} from "../../util";
import stylesheet, {
    getEmptyMediaStyle
} from "../../stylesheet";
import Skeleton from "../../../skeleton";

const EmptyMediaBase: FC<EmptyPartContentProps<IEmptyMediaProps>> = ({
    "aria-hidden": ariaHidden = true,
    customTheme: customThemeProp,
    icon: IconProp,
    children,
    iconSize,
    context,
    style,
    ...props
}) => {
    const customTheme = customThemeProp ?? context.customTheme;

    const {
        shapeConfigs,
        radiuses,
        borders
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        colors: currentColors,
        isLoading,
        measures,
        type
    } = context;

    const isChildrenMedia = !IconProp && Children.toArray(children).length > 0;

    const CurrentIcon = IconProp ?? (isChildrenMedia ? undefined : EMPTY_TYPE_ICONS[type]);

    const renderMedia = () => {
        if(isLoading) {
            return <Skeleton
                height={measures.mediaSize}
                width={measures.mediaSize}
                customTheme={customTheme}
                radius="actions"
                variant="block"
            />;
        }

        if(!CurrentIcon) {
            return children;
        }

        return <View
            style={[
                stylesheet.media,
                getEmptyMediaStyle({
                    colors: currentColors,
                    shapeConfigs,
                    measures,
                    radiuses,
                    borders
                })
            ]}
        >
            <CurrentIcon
                customColor={currentColors.iconColor}
                size={iconSize ?? measures.iconSize}
                color={currentColors.iconColorKey}
            />
        </View>;
    };

    return <View
        {...props}
        aria-hidden={ariaHidden}
        style={[
            style,
            stylesheet.media
        ]}
    >
        {renderMedia()}
    </View>;
};
export default withEmptyContext("media", EmptyMediaBase);
